export default {
    init() {
    // JavaScript to be fired on the about us page
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js